/**
 * To-Do system constants.
 */

export const TIME_BLOCKS = [
  { key: 'morning', label: 'Morning', icon: '🌅' },
  { key: 'midday', label: 'Mid-Day', icon: '☀️' },
  { key: 'evening', label: 'Evening', icon: '🌙' },
  { key: 'overall', label: 'Overall', icon: '📋' },
];

export const MAX_ITEMS_PER_BLOCK = 10;

export const JOURNAL_QUESTIONS = [
  {
    key: 'journal_1',
    question:
      'What I did differently today — one choice, action, or response that the version of me who started this process would not have made',
    placeholder: 'Describe something you did differently today...',
  },
  {
    key: 'journal_2',
    question:
      "What I'm taking with me into tomorrow — one thing I'm continuing, protecting, or building on",
    placeholder: 'What are you carrying forward into tomorrow...',
  },
];
